var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
        _vm._v("站点消费风控数据")
      ]),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("span", { staticClass: "demonstration" }, [_vm._v("选择日期")]),
          _c("el-date-picker", {
            staticStyle: { width: "20rem !important" },
            attrs: {
              editable: false,
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "timestamp"
            },
            model: {
              value: _vm.datePickerValue,
              callback: function($$v) {
                _vm.datePickerValue = $$v
              },
              expression: "datePickerValue"
            }
          }),
          _c(
            "el-select",
            {
              attrs: {
                "value-key": "statTag",
                size: "small",
                placeholder: "请选择站点"
              },
              model: {
                value: _vm.selectedStation,
                callback: function($$v) {
                  _vm.selectedStation = $$v
                },
                expression: "selectedStation"
              }
            },
            [
              _c("el-option", {
                attrs: { label: "请选择站点", value: 0, disabled: "" }
              }),
              _vm._l(_vm.asyncStations, function(item) {
                return _c("el-option", {
                  key: item.ID,
                  attrs: { label: item.statTag, value: item }
                })
              })
            ],
            2
          ),
          _c(
            "el-button",
            {
              attrs: {
                loading: _vm.downloadLoading,
                size: "small",
                type: "primary",
                icon: "el-icon-search"
              },
              on: { click: _vm.riskSearch }
            },
            [_vm._v(" 查询 ")]
          ),
          _vm.userInfo.authorityId === "888" ||
          _vm.userInfo.authorityId === "9994" ||
          _vm.userInfo.authorityId === "9990"
            ? _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.downloadLoading,
                    size: "small",
                    type: "warning",
                    icon: "el-icon-document"
                  },
                  on: {
                    click: function($event) {
                      return _vm.exportExcel(_vm.excelSheets, "消费风控数据")
                    }
                  }
                },
                [_vm._v(" 下载 ")]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c("h3", [_vm._v("所选日期内消费风控统计：")]),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.downloadLoading,
                      expression: "downloadLoading"
                    }
                  ],
                  ref: "dailyConsumeRiskData",
                  staticStyle: { width: "100%" },
                  attrs: {
                    id: "dailyConsumeRiskData",
                    data: _vm.dailyConsumeRiskData,
                    "highlight-current-row": "",
                    border: "",
                    height: "740"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      fixed: "",
                      label: "用户",
                      align: "center",
                      prop: "user.mobile"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.getConsumeList(
                                      scope.row.user.mobile
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(scope.row.user.mobile))]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "",
                      label: "类型",
                      align: "center",
                      width: "60px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type:
                                    scope.row.riskType === "svc"
                                      ? "warning"
                                      : "primary"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.riskType === "svc" ? "卡" : "会员"
                                  )
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "天数",
                      width: "60px",
                      align: "center",
                      prop: "riskStationDays"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "次数",
                      width: "60px",
                      align: "center",
                      prop: "riskStationOrders"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "油机",
                      align: "center",
                      width: "100px",
                      prop: "riskStationSaleAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "升数",
                      align: "center",
                      prop: "riskStationOilMass"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "实付",
                      width: "100px",
                      align: "center",
                      prop: "riskStationAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "总优惠",
                      align: "center",
                      prop: "riskStationDiscount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "会员优惠",
                      align: "center",
                      prop: "riskStationDiscountAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "券优惠",
                      width: "80px",
                      align: "center",
                      prop: "riskStationCouponDiscount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "积分优惠",
                      width: "80px",
                      align: "center",
                      prop: "riskStationPointDiscount"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _c("h3", [_vm._v("每班消费风控统计：（所选日期为某天时显示）")]),
              _c(
                "el-table",
                {
                  ref: "shiftConsumeRiskData",
                  staticStyle: { width: "100%" },
                  attrs: {
                    id: "shiftConsumeRiskData",
                    data: _vm.shiftConsumeRiskData,
                    "highlight-current-row": "",
                    border: "",
                    height: "740"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      fixed: "",
                      label: "班次",
                      align: "center",
                      prop: "shiftName"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "",
                      label: "用户",
                      align: "center",
                      prop: "user.mobile"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "类型", align: "center", width: "60px" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type:
                                    scope.row.riskType === "svc"
                                      ? "warning"
                                      : "primary"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.riskType === "svc" ? "卡" : "会员"
                                  )
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "次数",
                      width: "60px",
                      align: "center",
                      prop: "riskStationOrders"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "油机",
                      align: "center",
                      prop: "riskStationSaleAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "升数",
                      align: "center",
                      prop: "riskStationOilMass"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "实付",
                      align: "center",
                      prop: "riskStationAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "总优惠",
                      align: "center",
                      prop: "riskStationDiscount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "会员优惠",
                      align: "center",
                      prop: "riskStationDiscountAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "券优惠",
                      width: "80px",
                      align: "center",
                      prop: "riskStationCouponDiscount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "积分优惠",
                      width: "80px",
                      align: "center",
                      prop: "riskStationPointDiscount"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }